import React,{useEffect} from 'react';
import FaqGoldBondsUI from '../component/FaqGoldBondsUI'
const FaqGoldBonds = ()=>{
    useEffect(()=>{
        window.scrollTo(0,0)
      },[])
    return(
        <FaqGoldBondsUI/>
    )
}

export default FaqGoldBonds